import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCloudflareAuth } from '../contexts/CloudflareAuthContext';
import { logger } from '../utils/logger';
import LockedContent from './LockedContent';

interface MembershipProtectedRouteProps {
  children: React.ReactNode;
}

const MembershipProtectedRoute: React.FC<MembershipProtectedRouteProps> = ({ children }) => {
  const { currentUser, userDetails, loading } = useCloudflareAuth();

  if (loading) {
    return (
      <div className="min-h-[400px] flex items-center justify-center bg-gray-900/5 rounded-xl">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!currentUser) {
    logger.warn('Please login to continue', null, { showToast: true });
    return <Navigate to="/login" replace />;
  }

  const isActiveMember = userDetails?.memberStatus?.toLowerCase() === 'active';

  if (!isActiveMember) {
    return <LockedContent />;
  }

  return <>{children}</>;
};

export default MembershipProtectedRoute;
